export const NCE_PICKER_SERVICES: string[] = [
    'office-365',
    'power-bi',
    'dynamics-365',
    'intune',
    'ems',
    'office-365-secure',
];
